/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { uniqueNamesGenerator } from 'unique-names-generator';

export const getUniqueName = (configs?: { useDash?: boolean }) => {
  return uniqueNamesGenerator({
    dictionaries: [adjectives, animals],
    length: 2,
    separator: configs?.useDash ? '-' : '_',
  });
};

const adjectives = [
  'abundant',
  'accomplished',
  'accurate',
  'adorable',
  'adventurous',
  'agreeable',
  'alert',
  'ambitious',
  'amiable',
  'amused',
  'artistic',
  'attentive',
  'balanced',
  'beautiful',
  'blessed',
  'blissful',
  'brave',
  'bright',
  'brilliant',
  'calm',
  'capable',
  'careful',
  'charming',
  'cheerful',
  'clear',
  'clever',
  'comfortable',
  'confident',
  'considerate',
  'content',
  'cooperative',
  'courageous',
  'creative',
  'curious',
  'dazzling',
  'delightful',
  'determined',
  'diligent',
  'dynamic',
  'eager',
  'efficient',
  'elegant',
  'eloquent',
  'energetic',
  'enthusiastic',
  'excellent',
  'excited',
  'fabulous',
  'fair',
  'faithful',
  'fantastic',
  'favorable',
  'friendly',
  'fun',
  'generous',
  'gentle',
  'genuine',
  'glad',
  'glorious',
  'good',
  'graceful',
  'grateful',
  'great',
  'happy',
  'harmonious',
  'healthy',
  'helpful',
  'honest',
  'honorable',
  'humorous',
  'imaginative',
  'incredible',
  'independent',
  'innovative',
  'inspired',
  'intelligent',
  'interested',
  'jolly',
  'joyful',
  'kind',
  'lively',
  'lovely',
  'loyal',
  'lucky',
  'magnificent',
  'marvelous',
  'nice',
  'optimistic',
  'passionate',
  'patient',
  'peaceful',
  'perfect',
  'pleasant',
  'positive',
  'powerful',
  'precious',
  'proud',
  'quick',
  'quiet',
  'ready',
  'reliable',
  'remarkable',
  'resolute',
  'resourceful',
  'respectful',
  'responsible',
  'robust',
  'safe',
  'satisfied',
  'secure',
  'sincere',
  'skillful',
  'smart',
  'smile',
  'splendid',
  'successful',
  'super',
  'talented',
  'thoughtful',
  'thrilled',
  'trustworthy',
  'vibrant',
  'victorious',
  'vigorous',
  'warm',
  'wise',
  'wonderful',
  'worthy',
  'zestful',
];

const animals = [
  'alligator',
  'alpaca',
  'angelfish',
  'bear',
  'beaver',
  'bird',
  'butterfly',
  'camel',
  'cat',
  'cheetah',
  'chicken',
  'coyote',
  'deer',
  'dinosaur',
  'dog',
  'dolphin',
  'dragon',
  'dragonfly',
  'duck',
  'eagle',
  'elephant',
  'fish',
  'fox',
  'frog',
  'giraffe',
  'goat',
  'goldfish',
  'gorilla',
  'hamster',
  'kangaroo',
  'leopard',
  'lion',
  'octopus',
  'panda',
  'parrot',
  'penguin',
  'rabbit',
  'raccoon',
  'shark',
  'sheep',
  'squirrel',
  'swan',
  'tiger',
  'turtle',
  'whale',
  'wolf',
  'zebra',
];
